import * as Sentry from "@sentry/nextjs";

const { sentryIgnoreOptions } = require("./sentry.filters");
const { SENTRY_ENVIRONMENT, isSentryEnabled } = require("./sentry.env");

const GLITCHTIP_DSN =
  process.env.SENTRY_DSN ||
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  "https://3c545b4a9513413a9de51727e7ee8fb4@glitchtip.farkop.ru/1";

Sentry.init({
  dsn: GLITCHTIP_DSN,
  enabled: isSentryEnabled,
  environment: SENTRY_ENVIRONMENT,
  tracesSampleRate: 0.01,
  autoSessionTracking: false,
  tunnel: "/api/glitchtip-tunnel/",
  ...sentryIgnoreOptions,
});
